<template>
	<section class="sidebar">
		<ul class="sidebar-menu" id="menuArea">
			<li v-for="item in items" class="treeview" :data-ref="item.ref">
				<a href="#">
					<i :class="item.icon"></i>
					<span>{{ item.name }}</span>
					<span class="pull-right-container"><i class="fa fa-angle-left pull-right"></i></span>
				</a>
				<ul v-if="item.childrens" class="treeview-menu">
					<li v-for="subitem in item.childrens" :class="subitem.childrens?'treeview-sub':''" :data-pref="item.ref" :data-ref="subitem.ref">
						<a v-if="subitem.childrens" href="#">
							<i :class="subitem.icon"></i>
							<span>{{ subitem.name }}</span>
							<span class="pull-right-container"><i class="fa fa-angle-left pull-right"></i></span>
						</a>
						<router-link v-else :to="subitem.href">
							<i :class="subitem.icon"></i>
							<span>{{ subitem.name }}</span>
						</router-link>
						<ul v-if="subitem.childrens" class="treeview-menu">
							<li v-for="childitem in subitem.childrens" :class="childitem.childrens?'treeview-sub':''" :data-pref="subitem.ref" :data-ref="childitem.ref">
								<a v-if="childitem.childrens" href="#">
									<i :class="childitem.icon"></i>
									<span>{{ childitem.name }}</span>
									<span class="pull-right-container"><i class="fa fa-angle-left pull-right"></i></span>
								</a>
								<router-link v-else :to="childitem.href">
									<i :class="childitem.icon"></i>
									<span>{{ childitem.name }}</span>
								</router-link>
							</li>
						</ul>
					</li>
				</ul>
			</li>
		</ul>
	</section>
</template>

<script>
import $ from 'jquery'
import _ from 'lodash'
import carMenu from './menuCfg/car'
import erpMenu from './menuCfg/erp'

const _p = global.xwCommon

let items = {},
	methods = {
	setArea(){

		let cur = _p.getStoredProp("staff/currentQuery"),
			menu = cur.menu , area = this.sideparamas;
			/*let area = "car";*/
			// console.log('hello')
              if(!area){area = "car"};
		if(area){
			switch(area){

				// case 'admin':
				// 	this.items = erpMenu
				// 	break;
				// case 'car':
				// 	this.items = carMenu
				// 	break;
				default:
					let tree = _.find(menu,(o) => { return o.ref == area })
					if(tree.childrens) this.items = tree.childrens;
					else 
					this.$alert("无子菜单,请联系管理员");
				
					break;

			}

		}
			
		// console.log(this.items)
		this.$nextTick(() =>{
			this.setActive(this.$route.name)
		})
		
	},
	setActive(name){

		let $item = $("#menuArea").find('[data-ref="'+name+'"]'),
			pref = $item.data("pref");
			// console.log('hloo')
			// console.log($item)

		$item.siblings().removeClass("active")
		$item.addClass("active")
		if(pref) this.setActive(pref)
	}
}

export default {
  	name: 'menu', methods,
  	props:['sideparamas'],

  	data(){
  		return {items}
  	},
  	watch: {
  		'$route':function(to) {
  			this.setArea()
  		},
  		'area':function(){
  			this.setArea()
  		}
  	},
  	mounted() {
  		//console.log(this.$route.name)
  		this.setArea()
  		
  	}
}
</script>



// WEBPACK FOOTER //
// menu.vue?447bf27a